<mat-form-field appearance="outline" *ngIf="locations">
  <mat-label>{{ title | titlecase }}</mat-label>
  <mat-select [formControl]="control">
    <mat-option *ngFor="let location of locations" [value]="location._id">
      {{ location.name }} - {{ location.address.streetNumber }},
      {{ location.address.streetName }}
    </mat-option>
  </mat-select>
</mat-form-field>
